<template>
  <v-alert
    :timeout="timer"
    v-model="show_toast"
    bottom
    right
    dismissible
    prominent
    :type="type"
    transition="scale-transition"
    style="position: absolute; right: 0; bottom: 0; z-index: 1000;"
  >
    {{ message }}
  </v-alert>
</template>

<script>
export default {
  name: "Toast",
  data() {
    return{
      show_toast: false,
      message: '',
      type: 'success',
      timer: 3000,
      timeout: null
    }
  },
  methods:{
    show(data) {
      this.message = data.message || ''
      this.type = data.type || 'success'
      this.timer = data.timer || 3000
      this.show_toast = true
      this.timeout && clearTimeout(this.timeout)
      const me = this
      this.timeout = setTimeout(() => {
        me.show_toast = false
      }, this.timer)
    }
  }
}
</script>